<template>
  <layout name="Settings">
    <div>
      <VSettingsSidebarLayoutHeading title="Notifications" />
      <AccountSettingsEmailNotificationsTable
        :daily_reports="Boolean(getUser.daily_reports)"
        :monthly_reports="Boolean(getUser.monthly_reports)"
        :daily_emails="_getNotificationListEmails('daily')"
        :monthly_emails="_getNotificationListEmails('monthly')"
      ></AccountSettingsEmailNotificationsTable>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/layouts/Layout";
import VSettingsSidebarLayoutHeading from "@/components/VSettingsSidebarLayoutHeading";
import AccountSettingsForm from "@/components/AccountSettingsForm";
import { mapActions, mapGetters } from "vuex";
import withToasted from "@/mixins/withToasted";
import withFormUtils from "@/mixins/withFormUtils";

import AccountSettingsEmailNotificationsTable from "@/components/AccountSettingsEmailNotificationsTable";

export default Vue.component("AccountNotifications", {
  metaInfo: {
    title: "Settings - Notifications"
  },

  components: {
    Layout,
    VSettingsSidebarLayoutHeading,
    AccountSettingsForm,
    AccountSettingsEmailNotificationsTable
  },

  data() {
    return {
      name: "accountSettings"
    };
  },

  methods: {
    _getNotificationListEmails(period) {
      const emails =
        this.getUser[`${period}_notification_emails`] || this.getUser.email;

      if (!emails) {
        return;
      }

      return emails.split(",");
    },

    ...mapActions("account", ["updateUser"]),
    ...mapActions("forms", ["updateValues"])
  },

  mixins: [withToasted, withFormUtils],

  computed: {
    ...mapGetters("account", ["isLoading", "getUser"])
  }
});
</script>

<style lang="scss" scoped>
.account-notifications-form__wrapper {
  margin-top: 48px;
  max-width: 500px;
}

h1 {
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 15px;
  margin-top: 50px;
  color: $button-dark-color;
}
</style>

<style lang="scss">
button.dark.inverted.account-save-button {
  color: #7c8ca3;
  border-color: #7c8ca3;

  &:hover {
    color: $primary-color;
    border-color: $primary-color;
    background: transparent;
  }
}
</style>
